class HttpProvider {
  constructor(http, path, paramReducer, responseType) {
    this._http = http;
    this._path = path;
    this._paramReducer = paramReducer;
    this._responseType = responseType;
  }

  async get(key) {
    let params;

    if (key) {
      params = this._paramReducer ? this._paramReducer(key) : key;
    }

    let response = await this._http.request({
      method: "get",
      url: this._path,
      responseType: this._responseType ?? "json",
      params,
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
              if (value === null || value === undefined) continue;
          if (Array.isArray(value)) {
            value.forEach((item) => query.append(key, item));
          } else {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });

    return response.data;
  }
}

export default HttpProvider;
